import { Repository } from '../../../core/context/repository';
import { type AssetProtectionGoalImpact } from './entity';

export class AssetProtectionGoalImpacts extends Repository<AssetProtectionGoalImpact> {
    getByAssetId(assetId: string): AssetProtectionGoalImpact[] {
        return this.items.filter((entity) => entity.assetId === assetId);
    }

    getByAssetIdAndProtectionGoalId(
        assetId?: string,
        protectionGoalId?: string,
    ): AssetProtectionGoalImpact | undefined {
        if (!assetId || !protectionGoalId) {
            return undefined;
        }
        return this.items.find(
            (entity) =>
                entity.assetId === assetId &&
                entity.protectionGoalId === protectionGoalId,
        );
    }
}
